(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ds-braze-signup"] && !Shopify.designMode) return;
  try {
    
    class BrazeSignupForm extends HTMLElement {
        constructor() {
			super()
			this.firstNameInput = this.querySelector(':scope input.field__input[name="contact[firstName]"]') ? this.querySelector(':scope input.field__input[name="contact[firstName]"]') : null;
			this.lastNameInput = this.querySelector(':scope input.field__input[name="contact[lastName]"]') ? this.querySelector(':scope input.field__input[name="contact[lastName]"]') : null;
			this.phoneInput = this.querySelector(':scope input.field__input[name="contact[phone]"]') ? this.querySelector(':scope input.field__input[name="contact[phone]"]') : null;
			this.emailInput = this.querySelector(':scope input.field__input[name="contact[email]"]') ? this.querySelector(':scope input.field__input[name="contact[email]"]') : null;
			this.submitButton = this.querySelector(':scope button.newsletter-form__button') ? this.querySelector(':scope button.newsletter-form__button') : null;
			this.setButtonListener(this.submitButton);
		}

        setButtonListener(button){
            button.addEventListener('click', this.submitBrazeSignup.bind(this));
        }

        showSuccessFlag(){
            let flag = this.querySelector(':scope .success-flag');
			flag.classList.add('show-flag');
			setTimeout(() => {
				flag.classList.remove('show-flag');
			}, 5000);
        }

        submitBrazeSignup(){
            event.preventDefault();
            const notificationType = "opted_in";
            const userToUpdate = braze.getUser();
            userToUpdate.setFirstName(this.firstNameInput.value);
            if(this.lastNameInput.value != ''){
                userToUpdate.setLastName(this.lastNameInput.value);
            }
            if(this.phoneInput.value != ''){
                userToUpdate.setPhoneNumber(this.phoneInput.value);
            }
            userToUpdate.setEmail(this.emailInput.value);
            userToUpdate.setEmailNotificationSubscriptionType(notificationType);
            if(userToUpdate.setFirstName(this.firstNameInput.value) && userToUpdate.setEmail(this.emailInput.value) && userToUpdate.setEmailNotificationSubscriptionType(notificationType)){
                this.showSuccessFlag();
            }
    }
}

    customElements.define('braze-signup-form', BrazeSignupForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ds-featured-product"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('product-modal')) {
    customElements.define('product-modal', class ProductModal extends ModalDialog {
        constructor() {
        super();
    }

    hide() {
        super.hide();
    }

    show(opener) {
        super.show(opener);
        this.showActiveMedia();
    }

    showActiveMedia() {
        this.querySelectorAll(`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute("data-media-id")}"])`).forEach((element) => {
            element.classList.remove('active');
            }
        )
        const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
        const activeMediaTemplate = activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
        activeMedia.classList.add('active');
        activeMedia.scrollIntoView();

        const container = this.querySelector('[role="document"]');
        container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

        if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMediaContent && activeMediaContent.querySelector('.js-youtube'))
            activeMedia.loadContent();
        }
    });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
	class LocalizationForm extends HTMLElement {
		constructor() {
			super();
			this.elements = {
				input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
				button: this.querySelector('button'),
				panel: this.querySelector('ul'),
			};
			this.elements.button.addEventListener('click', this.openSelector.bind(this));
			this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
			this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

			this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
		}

		hidePanel() {
			this.elements.button.setAttribute('aria-expanded', 'false');
			this.elements.panel.setAttribute('hidden', true);
		}

		onContainerKeyUp(event) {
			if (event.code.toUpperCase() !== 'ESCAPE') return;

			this.hidePanel();
			this.elements.button.focus();
		}

		onItemClick(event) {
			event.preventDefault();
			const form = this.querySelector('form');
			this.elements.input.value = event.currentTarget.dataset.value;
			if (form) form.submit();
		}

		openSelector() {
			this.elements.button.focus();
			this.elements.panel.toggleAttribute('hidden');
			this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
		}

		closeSelector(event) {
			const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
			if (event.relatedTarget === null || shouldClose) {
				this.hidePanel();
			}
		}
	}

	customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart-footer"]) return;
  try {
    
	class CartNote extends HTMLElement {
		constructor() {
			super();

			this.addEventListener('change', debounce((event) => {
				const body = JSON.stringify({ note: event.target.value });
				fetch(`${routes.cart_update_url}`, {...fetchConfig(), ...{ body }});
			}, 300))
		}
	}

	customElements.define('cart-note', CartNote);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
	class ProductRecommendations extends HTMLElement {
		constructor() {
			super();

			const handleIntersection = (entries, observer) => {
				if (!entries[0].isIntersecting) return;
				observer.unobserve(this);

				fetch(this.dataset.url)
					.then(response => response.text())
					.then(text => {
						const html = document.createElement('div');
						html.innerHTML = text;
						const recommendations = html.querySelector('product-recommendations');
						if (recommendations && recommendations.innerHTML.trim().length) {
							this.innerHTML = recommendations.innerHTML;
						}
					})
					.catch(e => {
						console.error(e);
					});
			}

			new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
		}
	}

	customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();
})();
